<template>
	<div class="page">
		<!-- your page -->
        <div class="evaluateList">
        	<div class="item" v-for="(item,index) in list" :key="index">
        		<div class="user">
        			<div class="avatar">
        				<div class="avatarIn">
        					<img :src="item.user.avatar" alt="">
        				</div>
        			</div>
					<div class="username">
						{{item.user.nickname}}
					</div>
					<div class="time">
						{{item.time}}
					</div>
        		</div>
				<div class="star">
					<div class="starTitle">
						评分：
					</div>
					<div class="starItem" v-for="(tab,tabIndex) in item['star']" :key="tabIndex">
						<img :src="tab" alt="">
					</div>
				</div>
				<div class="cont">
					{{item.cont}}
				</div>
				<div class="imgList">
					<div class="imgItem" v-for="(unit,unitIndex) in item['imgList']" :key="unitIndex">
						<img :src="unit" alt="">
					</div>
				</div>
        	</div>
        </div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'evaluateList',
		props:['eid'],
		data(){
			return {
				page:1,
				list:[
					// {"user":{"avatar":"","username":"天下第一万古人皇innovation吕布李信衡"},"time":"2019-5-9","star":[require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star.png')],"cont":"评价内容","imgList":[require('../assets/index/imgList1.jpg'),require('../assets/index/imgList2.jpg'),require('../assets/index/imgList3.jpg'),require('../assets/index/imgList4.jpg'),require('../assets/index/imgList5.jpg')]},
					// {"user":{"avatar":"","username":"天下第一万古人皇innovation吕布李信衡"},"time":"2019-5-9","star":[require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star.png')],"cont":"评价内容","imgList":[require('../assets/index/imgList1.jpg'),require('../assets/index/imgList2.jpg'),require('../assets/index/imgList3.jpg'),require('../assets/index/imgList4.jpg'),require('../assets/index/imgList5.jpg')]},
					// {"user":{"avatar":"","username":"天下第一万古人皇innovation吕布李信衡"},"time":"2019-5-9","star":[require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star.png')],"cont":"评价内容","imgList":[require('../assets/index/imgList1.jpg'),require('../assets/index/imgList2.jpg'),require('../assets/index/imgList3.jpg'),require('../assets/index/imgList4.jpg'),require('../assets/index/imgList5.jpg')]},
					// {"user":{"avatar":"","username":"天下第一万古人皇innovation吕布李信衡"},"time":"2019-5-9","star":[require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star.png')],"cont":"评价内容","imgList":[require('../assets/index/imgList1.jpg'),require('../assets/index/imgList2.jpg'),require('../assets/index/imgList3.jpg'),require('../assets/index/imgList4.jpg'),require('../assets/index/imgList5.jpg')]},
					// {"user":{"avatar":"","username":"天下第一万古人皇innovation吕布李信衡"},"time":"2019-5-9","star":[require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star.png')],"cont":"评价内容","imgList":[require('../assets/index/imgList1.jpg'),require('../assets/index/imgList2.jpg'),require('../assets/index/imgList3.jpg'),require('../assets/index/imgList4.jpg'),require('../assets/index/imgList5.jpg')]},
					// {"user":{"avatar":"","username":"天下第一万古人皇innovation吕布李信衡"},"time":"2019-5-9","star":[require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star.png')],"cont":"评价内容","imgList":[require('../assets/index/imgList1.jpg'),require('../assets/index/imgList2.jpg'),require('../assets/index/imgList3.jpg'),require('../assets/index/imgList4.jpg'),require('../assets/index/imgList5.jpg')]},
					// {"user":{"avatar":"","username":"天下第一万古人皇innovation吕布李信衡"},"time":"2019-5-9","star":[require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star.png')],"cont":"评价内容","imgList":[require('../assets/index/imgList1.jpg'),require('../assets/index/imgList2.jpg'),require('../assets/index/imgList3.jpg'),require('../assets/index/imgList4.jpg'),require('../assets/index/imgList5.jpg')]},
					// {"user":{"avatar":"","username":"天下第一万古人皇innovation吕布李信衡"},"time":"2019-5-9","star":[require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star2.png'),require('../assets/index/star.png')],"cont":"评价内容","imgList":[require('../assets/index/imgList1.jpg'),require('../assets/index/imgList2.jpg'),require('../assets/index/imgList3.jpg'),require('../assets/index/imgList4.jpg'),require('../assets/index/imgList5.jpg')]}
				]
			}
		},
		methods:{
			fetchData(){
				var eid = this.eid
				var page = this.page
				var data = {
					page: 1,  //页数
					limit: 5,  // 条数
					goods_id: eid,   //商品id
					method: 'goods.getgoodscomment'
				}
				var list = this.list
				var that = this
				this.request(data,function(res){
					if(res.status){
						var reList = res.data.list
						for (var i = 0; i < reList.length; i++) {
							var item = reList[i]
							var imgList = new Array()
							if(item.images_url){
								for (var k = 0; k < item.images_url.length; k++) {
								    imgList.push(item.images_url[k])
								}
							}
							var score = item.score
							var star = new Array()
							for (var k = 1; k <= 5; k++) {
								if(k<=score){
									star.push(require('../assets/index/star2.png'))
								}else{
									star.push(require('../assets/index/star.png'))
								}
							}
							var time = (new Date(parseInt(item.ctime)*1000)).toLocaleString().replace(/:\d{1,2}$/,' ');
							if(item.user!=null){
								var obj = {
									"user":{
										"avatar":item.user.avatar,
										"nickname":item.user.nickname
									},
									"time":time,
									"star":star,
									"cont":item.content,
									"imgList":imgList
								}
								list.push(obj)
							}
						}
						that.list = list
					}else{
						var msg = res.msg
						that.globalTest('error',msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			var eid = this.$props.eid
			this.eid = eid
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
    .evaluateList{
    	width:100%;
    }
	.item{
		width: 100%;
		border-bottom: 1px solid #B3B3B3;
	}
	.item .user{
		width: 100%;
		height: 90px;
		position: relative;
		line-height: 90px;
	}
	.item .user .avatar{
		width: 90px;
		height: 100%;
		position: absolute;
		left: 0px;
		top: 0px;
	}
	.item .user .avatar .avatarIn{
		width: 70px;
		height: 70px;
		border: 1px solid #e3e3e3;
		border-radius: 50%;
		margin:10px auto;
		overflow: hidden;
	}
	.item .user .avatar .avatarIn img{
		width: 100%;
		height: 100%;
	}
	.item .user .username{
		width: 100%;
		height: 100%;
		padding-left: 90px;
		padding-right: 150px;
		box-sizing: border-box;
	}
	.item .user .time{
		width: 150px;
		height: 100%;
		position: absolute;
		top: 0px;
		right: 0px;
	}
	.item .star{
		width: 100%;
		height: 50px;
		line-height: 50px;
	}
	.item .star .starTitle{
		width: 70px;
		height: 100%;
		float: left;
		padding-left: 10px;
		box-sizing: border-box;
	}
	.item .star .starItem{
		width:40px;
		height: 100%;
		float: left;
	}
	.item .star .starItem img{
		width: 20px;
		height: 20px;
		display: block;
		margin:15px auto;
	}
	.item .cont{
		width: 100%;
		padding:10px;
		box-sizing: border-box;
		line-height: 24px;
	}
	.item .imgList{
		width: 100%;
		font-size: 0px;
		letter-spacing:-6px;
		padding-bottom:10px;
	}
	.item .imgList .imgItem{
		width: 150px;
		height: 120px;
		display: inline-block;
		margin-left: 10px;
		letter-spacing: normal;
		vertical-align: top;
		overflow: hidden;
		border:1px solid #b3b3b3;
		box-sizing: border-box;
	}
	.item .imgList .imgItem img{
		width: 100%;
	}
</style>
